// oxlint-disable typescript/no-duplicate-enum-values -- Default intentionally aliases US
enum DateTimeFormat {
  US = 'US',
  International = 'International',
  Default = 'US',
}

export default DateTimeFormat
